<div class="mt-3">
    <div class="row">
        <div class="col-12 exec-summ">
            <div class="row">
                <div class="col pr-1">
                    <div class="box">
                        <div>
                            <div class="details" style="color:black">
                                {{perResults.testcaseExecSumm?.activeThreads}}/{{perResults.testcaseExecSumm?.performanceRequest?.noOfUsers}}
                            </div>
                            <div class="heading">
                                Active / Peak Users
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col pr-1">
                    <div class="box">
                        <div [title]="'Start Time (PST) : ' + (this.perResults.testcaseExecSumm.performanceRequest.startTime | date: 'd-MM-yy, hh:mm:ss a') +
                                                                '\nEnd Time (PST) : ' +
                                                                (this.perResults.testcaseExecSumm.performanceRequest.endTime ?
                                                                    (this.perResults.testcaseExecSumm.performanceRequest.endTime | date: 'd-MM-yy, hh:mm:ss a') : 'NA')
                                                             ">
                            <div class="details" style="color:black">
                                {{secondsToDhms(perResults.testcaseExecSumm?.elapsedTime)}}
                            </div>
                            <div class="heading">
                                Elapsed Time <span style="font-size: .5rem;">(D hh:mm:ss)</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col pr-1">
                    <div class="box">
                        <div>
                            <div class="details" [ngStyle]="{'color': perResults.testcaseExecSumm?.errorPercentage > 5 ? 'red' : 'black'}">
                                {{perResults.testcaseExecSumm?.errorPercentage}}
                            </div>
                            <div class="heading">
                                Error (%)
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col pr-1">
                    <div class="box">
                        <div>
                            <div class="details" style="color:black">
                                {{perResults.testcaseExecSumm?.noOfHits || 0}}
                            </div>
                            <div class="heading">
                                {{perResults.testcaseExecSumm?.loadTestType === 'WEB' ? 'Total Transactions' : 'TotalHits'}}
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col pr-1">
                    <div class="box">
                        <div>
                            <div class="details" style="color:black">
                                {{perResults.testcaseExecSumm?.hitsPerSec.toFixed(2) || 0}}
                            </div>
                            <div class="heading" *ngIf="perResults.testcaseExecSumm?.loadTestType !== 'WEB'">
                                Hits Per Second
                            </div>
                            <div class="heading" *ngIf="perResults.testcaseExecSumm?.loadTestType === 'WEB'">
                                {{perResults.testcaseExecSumm?.loadTestType === 'WEB' ? 'Transaction Per Second' :
                                'Transaction Hits Per Second'}}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col pr-1">
                    <div class="box">
                        <div>
                            <div class="details" style="color:black">
                                {{perResults.testcaseExecSumm?.throughput}}
                            </div>
                            <div class="heading">
                                Throughput (Tps)
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>

    <div class="row" *ngIf="perResults.testcaseExecSumm?.performanceRequest.exceptionOccurred">
        <div class="col-md-12">
            {{perResults.testcaseExecSumm?.performanceRequest.exceptionMessage}}
        </div>
    </div>

    <div class="col-12 additional-info" style="display: flex;"
        *ngIf="perResults.testcaseExecSumm?.performanceRequest.errorMessage !== null">
        <div class="col" style="display: flex;">
            <div style="color: red; margin: 1px; font-size: 20px;">
                {{perResults.testcaseExecSumm?.performanceRequest.errorMessage}} </div>
        </div>
    </div>

    <!-- Display graph filter -->
     <div class="dotted-border mb-2">
        <div class="tableMatrix d-flex" (click)="showFilter = !showFilter">
            Filter

            <div class="ml-auto">
                <i class="fas fa-caret-right clickable collapse-icon" *ngIf="!showFilter"></i>
                <i class="fas fa-caret-down clickable collapse-icon" *ngIf="showFilter"></i>
            </div>
        </div>
        <div class="row mt-1 mb-1" *ngIf="showFilter">
            <div class="col-md-6">
                <ng-select class="custom-select-md" [ngClass]="{'disabled': selectedEndpoints.length > 0}" placeholder="Select Thread Group" [(ngModel)]="selectedThreadGroup"
                    [items]="threadGroupFilterList" bindLabel="value" bindValue="key" [multiple]="true" [searchable]="true"
                    ngModelOptions="{standalone: true}" [disabled]="selectedEndpoints.length > 0">
                    <ng-template ng-option-tmp let-item="item">
                        <div title="{{item.value}}" class="text-truncate">{{item.value}}</div>
                    </ng-template>
                </ng-select>
            </div>

            <div class="col-md-6">
                <ng-select class="custom-select-md" [ngClass]="{'disabled': selectedThreadGroup.length > 0}" placeholder="Select Endpoint(s)" [(ngModel)]="selectedEndpoints"
                    [items]="endpointFilterList" bindLabel="value" bindValue="key" [multiple]="true" [searchable]="true"
                    ngModelOptions="{standalone: true}" [disabled]="selectedThreadGroup.length > 0">
                    <ng-template ng-option-tmp let-item="item">
                        <div title="{{item.value}}" class="text-truncate">{{item.value}}</div>
                    </ng-template>
                </ng-select>
            </div>

            <div class="col-md-6 input-group mt-4" *ngIf="showNewGraphSection">
                <input [ngModel]="startDateTime" *ngIf="filterDurationType" class="form-control" placeholder="Start Date Time" (click)="openDateTimePopup(mymodal)" readonly/>
                <input [ngModel]="finalDisplayedStartTime" *ngIf="!filterDurationType" class="form-control" placeholder="Start Date Time" (click)="openDateTimePopup(mymodal)" readonly/>
                <div class="input-group-append">
                    <button class="btn btn-outline-primary" type="button" (click)="openDateTimePopup(mymodal)">
                        <i class="fas fa-calendar-plus ml-1 text-info"></i>
                    </button>
                    <button class="btn btn-outline-primary" (click)="resetFilter()">
                        <i class="fas fa-times ml-1 text-info"></i>
                    </button>
                </div>
            </div>

            <div class="col-md-6 input-group mt-4" *ngIf="showNewGraphSection">
                <input [ngModel]="endDateTime" *ngIf="filterDurationType" class="form-control" placeholder="End Date Time" (click)="openDateTimePopup(mymodal)" readonly/>
                <input [ngModel]="finalDisplayedEndTime" *ngIf="!filterDurationType" class="form-control" placeholder="End Date Time" (click)="openDateTimePopup(mymodal)" readonly/>
                <div class="input-group-append">
                    <button class="btn btn-outline-primary" (click)="openDateTimePopup(mymodal)">
                        <i class="fas fa-calendar-plus ml-1 text-info"></i>
                    </button>
                    <button class="btn btn-outline-primary" (click)="resetFilter()">
                        <i class="fas fa-times ml-1 text-info"></i>
                    </button>
                </div>
            </div>

            <div class="col-md-12 ml-auto mt-4">
                <label>Graph Filter</label>
                <ng-select class="custom-select-md" placeholder="Select graph type" [(ngModel)]="selectedGraphTypes" [items]="graphType"
                    bindLabel="name" bindValue="id" [multiple]="true" [searchable]="true" ngModelOptions="{standalone: true}" (change)="showSelectedGraphs($event)">
                    <ng-template ng-option-tmp let-item="item">
                        <div title="{{item.name}}" class="text-truncate">{{item.name}}</div>
                    </ng-template>
                </ng-select>
            </div>

            <div class="col-md-12 mt-2">
                <div class="text-right">
                    <button class="btn btn-sm btn-primary" style="color: white;padding-bottom: 6px;" (click)="getNewGraphDetails()">Filter</button>
                    <button class="btn btn-sm ml-2" style="background-color: rgb(77, 162, 177); color:white;padding-bottom: 6px;" (click)="clearAllFilters(); getNewGraphDetails()">Clear</button>
                </div>
            </div>
        </div>
     </div>

     <div class="mb-2 dotted-border">
        <!-- Response Summary -->
        <div class="tableMatrix d-flex align-items-center mb-1" (click)="showTableMetric = !showTableMetric">
            <span (click)="$event.stopPropagation()" class="mr-2">Response Summary</span>
            <input type="checkbox" (click)="showDetailReport($event.target.checked); $event.stopPropagation()" *ngIf="perResults?.testcaseExecSumm?.loadTestType === 'API' || perResults?.testcaseExecSumm?.loadTestType === 'GRAPHQL'">
            <span style="font-size: 12px;" class="ml-1" *ngIf="perResults?.testcaseExecSumm?.loadTestType === 'API' || perResults?.testcaseExecSumm?.loadTestType === 'GRAPHQL'">Show Detailed Table</span>
            <div class="ml-auto">
                <i class="fas fa-caret-right clickable collapse-icon" *ngIf="!showTableMetric"></i>
                <i class="fas fa-caret-down clickable collapse-icon" *ngIf="showTableMetric"></i>
            </div>
        </div>
        <div *ngIf="showTableMetric">
          <app-new-performance-response-summary [perResults]="perResults" [queueRes]="queueRes" [sortDirection]="sortDirection" (sortColumn)="sortByColumn($event)" *ngIf="!detailReportTable && (perResults?.testcaseExecSumm?.loadTestType === 'API' || perResults?.testcaseExecSumm?.loadTestType === 'GRAPHQL')"></app-new-performance-response-summary>
          <!-- Detail report Summary -->
          <app-new-performance-detail-report-summary [perResults]="perResults" [queueRes]="queueRes" [sortDirection]="sortDirection" (sortColumn)="sortByColumn($event)" *ngIf="(detailReportTable && (perResults?.testcaseExecSumm?.loadTestType === 'API' || perResults?.testcaseExecSumm?.loadTestType === 'GRAPHQL')) ||
            (!detailReportTable && perResults?.testcaseExecSumm?.loadTestType === 'WEB') ||
            (detailReportTable && perResults?.testcaseExecSumm?.loadTestType === 'WEB')"></app-new-performance-detail-report-summary>
        </div>
     </div>

    <!-- Display graph filter -->
    <div class="dotted-border" [hidden]="allResultGraphsNull">
        <div class="tableMatrix d-flex mb-1" (click)="showResultGraph = !showResultGraph; regenerateAllGraph()" >
            Chart Summary
            <div class="ml-auto mb-2">
                <i class="fas fa-caret-right clickable collapse-icon" *ngIf="!showResultGraph"></i>
                <i class="fas fa-caret-down clickable collapse-icon" *ngIf="showResultGraph"></i>
            </div>
        </div>
        <div class="d-flex" *ngIf="showResultGraph">
            <span class="ml-auto p-1">Full Screen</span>
            <ui-switch defaultBgColor="#cf6250" checkedTextColor="#fff" uncheckedTextColor="#fff" class="ml-2"
                     (click)="allFullScreen(fullScreen)"></ui-switch>
        </div>
        <div class="row" [hidden]="!showResultGraph">
            <div [ngClass]="showFullScreen(graphType[0].fullScreen)" [hidden]="!graphType[0].show">
                <div class="mt-2" id="plot-dataVUsers" #dataVUsers></div>
            </div>
            <div [ngClass]="showFullScreen(graphType[1].fullScreen)" [hidden]="!graphType[1].show">
                <div class="mt-2" id="plot-dataAvgTRes" #dataAvgTRes></div>
            </div>
            <div [ngClass]="showFullScreen(graphType[2].fullScreen)" [hidden]="!graphType[2].show">
                <div class="mt-2" id="plot-dataHitsPSec" #dataHitsPSec></div>
            </div>
            <div [ngClass]="showFullScreen(graphType[3].fullScreen)" [hidden]="!graphType[3].show">
                <div class="mt-2" id="plot-dataErrorCount" #dataErrorCount></div>
            </div>
            <div [ngClass]="showFullScreen(graphType[4].fullScreen)" [hidden]="!graphType[4].show">
                <div class="mt-2" id="plot-dataThroughput" #dataThroughput></div>
            </div>
        </div>
     </div>
</div>

<ng-template #mymodal let-modal>
  <div class="modal-header d-flex ">
    <div class="ml-auto mr-auto mt-4 mb-4">
        Use Absolute Timing
      <ui-switch size="small" class="ml-1 mr-1" [(ngModel)]="filterDurationType" checkedLabel="Absolute" uncheckedLabel="Relative" defaultBgColor="#cf6250" (change)="resetFilter()"></ui-switch>
        Use Time Relative to Test Start
      <!-- <ui-switch size="small" class="ml-3" checkedLabel="Detail-Report" uncheckedLabel="Report" defaultBgColor="#cf6250" (change)="showDetailReport()"></ui-switch> -->
    </div>
    <button type="button" class="close m-0" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row" *ngIf="filterDurationType">
      <div class="col-6">
        <div class="m-2">
          <label for=""> Start date & time (PST) <span class="text-danger">*</span> </label>
          <input class="form-control form-control-sm" type="text" ngbDatepicker #d1="ngbDatepicker" (click)="d1.toggle()" placeholder="dd-mm-yyyy" [(ngModel)]="startDate" [minDate]="minDate" [maxDate]="maxDate" />
        </div>
        <div class="m-2 d-flex">
          <ngb-timepicker class="m-auto" [meridian]="false" [size]="'small'" seconds="true" [(ngModel)]="startTime"></ngb-timepicker>
        </div>
        <div class="m-2 d-flex">
          <div>Start Time (PST): {{this.perResults.testcaseExecSumm.performanceRequest.startTime | date: 'd-MM-yy, hh:mm:ss a'}}</div>
        </div>
      </div>
      <div class="col-6">
        <div class="m-2">
          <label for=""> End date & time (PST) <span class="text-danger">*</span> </label>
          <input class="form-control form-control-sm" type="text" ngbDatepicker #d2="ngbDatepicker" (click)="d2.toggle()" placeholder="dd-mm-yyyy" [(ngModel)]="endDate" [minDate]="minDate" [maxDate]="maxDate" />
        </div>
        <div class="m-2 d-flex">
          <ngb-timepicker class="m-auto" [meridian]="false" [size]="'small'" seconds="true" [(ngModel)]="endTime"></ngb-timepicker>
        </div>
        <div class="m-2 d-flex">
          <div>End Time (PST): {{this.perResults.testcaseExecSumm.performanceRequest.endTime | date: 'd-MM-yy, hh:mm:ss a'}}</div>
        </div>
      </div>
    </div>
    <div class="row" *ngIf="!filterDurationType">
        <div class="col-6">
            <div for="" class="text-center mb-2"> <strong>Start Time </strong><span class="text-danger">*</span> </div>
            <div class="d-flex m-auto" [formGroup]="startTimeForm">
                <div style="width: 23%; margin: 5px;">
                    <label>DD</label> <br>
                    <input type="number" min="0" id="locator-name" class="form-control form-control-sm" placeholder="dd" formControlName="day" />
                </div>
                <div style="width: 23%; margin: 5px;">
                    <label>HH</label> <br>
                    <input type="number" max="59" min="0" id="locator-name" class="form-control form-control-sm" placeholder="hh" formControlName="hour" />
                </div>
                <div style="width: 23%; margin: 5px;">
                    <label>MM</label> <br>
                    <input type="number" max="59" min="0" id="locator-name" class="form-control form-control-sm" placeholder="mm" formControlName="minutes" />
                </div>
                <div style="width: 23%; margin: 5px;">
                    <label>SS</label> <br>
                    <input type="number" max="59" min="0" id="locator-name" class="form-control form-control-sm" placeholder="ss" formControlName="second" />
                </div>
            </div>
        </div>
        <div class="col-6">
            <div for="" class="text-center mb-2"><strong>End Time</strong><span class="text-danger">*</span> </div>
            <div class="d-flex m-auto" [formGroup]="endTimeForm">
                <div style="width: 23%; margin: 5px;">
                    <label>DD</label> <br>
                    <input type="number" id="locator-name" class="form-control form-control-sm" placeholder="dd" formControlName="day" />
                </div>
                <div style="width: 23%; margin: 5px;">
                    <label>HH</label> <br>
                    <input type="number" max="59" min="0" id="locator-name" class="form-control form-control-sm" placeholder="hh" formControlName="hour" />
                </div>
                <div style="width: 23%; margin: 5px;">
                    <label>MM</label> <br>
                    <input type="number" max="59" min="0" id="locator-name" class="form-control form-control-sm" placeholder="mm" formControlName="minutes" />
                </div>
                <div style="width: 23%; margin: 5px;">
                    <label>SS</label> <br>
                    <input type="number" max="59" min="0" id="locator-name" class="form-control form-control-sm" placeholder="ss" formControlName="second" />
                </div>
            </div>
        </div>
        <div class="col-12 d-flex mt-2">
            <div class="d-flex m-auto">
                Elapsed Time (D hh:mm:ss) : <strong>{{secondsToDhms(perResults.testcaseExecSumm?.elapsedTime)}}</strong>
            </div>
        </div>
      </div>
  </div>
  <div class="modal-footer">
    <div class="text-right">
        <button type="submit" *ngIf="filterDurationType" class="btn relay-btn save" (click)="saveFilter()">Save</button>
        <button type="submit" *ngIf="!filterDurationType" class="btn relay-btn save" [disabled]="startTimeForm.invalid || endTimeForm.invalid" (click)="saveFilter()">Save</button>
        <button type="button" class="btn relay-btn cancel" (click)="resetFilter(); modalService.dismissAll();">Cancel</button>

    </div>
  </div>
</ng-template>